import { Theme, Tooltip, Typography } from '@mui/material';
import { SxProps } from '@mui/system';

// Define content status enum since it's not in models/enums.ts
// Backend returns lowercase, we display as title case
export enum ContentStatus {
    DRAFT = 'draft',
    PUBLISHED = 'published',
    LIVE = 'live',
    ARCHIVED = 'archived',
}

export const ContentStatusToSx: Record<string, SxProps<Theme>> = {
    // Backend values (lowercase) - what we actually receive
    [ContentStatus.DRAFT]: {
        bgcolor: 'grey.300',
        color: 'primary.main',
    },
    [ContentStatus.PUBLISHED]: {
        bgcolor: 'action.active',
        color: 'primary.contrastText',
    },
    [ContentStatus.LIVE]: {
        bgcolor: 'warning.main',
        color: 'primary.main',
    },
    [ContentStatus.ARCHIVED]: {
        bgcolor: 'grey.700',
        color: 'primary.contrastText',
    },
};

export const getTooltipTitle = (status: string) => {
    const ContentStatusToToolTipTitle = {
        [ContentStatus.DRAFT]: '',
        [ContentStatus.PUBLISHED]: '',
        [ContentStatus.LIVE]: "This content is being used in a live campaign and can't be edited or deleted",
        [ContentStatus.ARCHIVED]: '',
    };

    return ContentStatusToToolTipTitle[status as ContentStatus];
};

export type Props = {
    status: string;
};

const ContentStatusText = ({ status }: Props) => {
    if (!status) {
        return null;
    }

    const displayStatus = status.toLowerCase();
    const title = getTooltipTitle(displayStatus);

    return (
        <Tooltip aria-label={title} data-testid="content-status-tooltip" title={title}>
            <Typography
                className="status-font"
                component="span"
                data-testid="content-status-text"
                role="status"
                variant="body2"
                sx={{
                    ...ContentStatusToSx[displayStatus],
                    borderRadius: '0.25rem',
                    padding: '0.125rem 0.75rem 0.25rem 0.75rem',
                    whiteSpace: 'nowrap',
                }}
            >
                {displayStatus}
            </Typography>
        </Tooltip>
    );
};

export default ContentStatusText;
